(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3117],{

/***/ 50119:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/governments",
      function () {
        return __webpack_require__(62851);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64434);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(algoliasearch__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = (algoliasearch__WEBPACK_IMPORTED_MODULE_0___default()("EKEGGUH63H", "MTYxNmZmYzhhMTFkNjI2NjcwZDFhZTM0ZmRmYjliY2U2MTQ3ZGJjMDgxY2M4YWE1ODA0YTJjZDQ5OTkyZmUwM3ZhbGlkVW50aWw9NDcyOTQyNjk1NQ=="));


/***/ }),

/***/ 31617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getIndexName; }
/* harmony export */ });
function getIndexName(index) {
    return "".concat(index, "_").concat("production");
};


/***/ }),

/***/ 79438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getCityType; }
/* harmony export */ });
function getCityType(governmentType) {
    return governmentType.replace(/(\b[a-z](?!\s))/g, function(letter) {
        return letter.toUpperCase();
    });
// if (governmentType === "county") {
//   return "County";
// } else if (governmentType === "township") {
//   return "Township";
// } else {
//   return "City";
// }
};


/***/ }),

/***/ 62851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ governments; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(29452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(45597);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-dom@6.31.0_kr5x6cjikajrhwznglqptdxk4q/node_modules/react-instantsearch-dom/server.js
var server = __webpack_require__(46514);
// EXTERNAL MODULE: ./components/search/utils/algoliaClient.ts
var algoliaClient = __webpack_require__(40243);
// EXTERNAL MODULE: ./components/search/utils/getIndexName.ts
var getIndexName = __webpack_require__(31617);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(87169);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(56262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/dynamic.js
var dynamic = __webpack_require__(74418);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectCurrentRefinements.js
var connectCurrentRefinements = __webpack_require__(13502);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/widgets/InstantSearch.js + 4 modules
var InstantSearch = __webpack_require__(13206);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectRefinementList.js
var connectRefinementList = __webpack_require__(93977);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectSearchBox.js
var connectSearchBox = __webpack_require__(23935);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/connectors/connectInfiniteHits.js
var connectInfiniteHits = __webpack_require__(86694);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-instantsearch-core@6.31.0_pybjzmhtnpk62btmxi5dirminu/node_modules/react-instantsearch-core/dist/es/widgets/Configure.js
var Configure = __webpack_require__(39274);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(35150);
// EXTERNAL MODULE: ./components/seo/SeoHead.tsx
var SeoHead = __webpack_require__(35692);
;// CONCATENATED MODULE: ./components/seo/GovernmentsPageSeo.tsx




function GovernmentsPageSeo() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeoHead/* default */.Z, {
        title: intl.formatMessage({
            defaultMessage: "Local Government Innovators",
            id: "G7xRda"
        }),
        description: intl.formatMessage({
            defaultMessage: "Discover the most innovative local government teams around the world.",
            id: "DNys4U"
        })
    });
};

// EXTERNAL MODULE: ./lib/utils/getCityType.ts
var getCityType = __webpack_require__(79438);
// EXTERNAL MODULE: ./lib/utils/notUndefinedOrNull.ts
var notUndefinedOrNull = __webpack_require__(86457);
// EXTERNAL MODULE: ./src/components/navbar/NavbarLayout.tsx + 62 modules
var NavbarLayout = __webpack_require__(71858);
;// CONCATENATED MODULE: ./src/components/home/FiltersToggleButton.tsx






function FiltersToggleButton(param) {
    var onClick = param.onClick, active = param.active;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
        variant: !active ? "primary" : "secondary",
        size: "sm",
        onClick: onClick,
        leftIcon: function(props) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                width: "17",
                height: "10",
                viewBox: "0 0 17 10",
                fill: "none"
            }, props), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.0714 2H0.0714417V0H16.0714V2ZM13.6713 6H2.47134V4H13.6713V6ZM4.87125 10H11.2712V8H4.87125V10Z",
                    fill: "currentColor"
                })
            }));
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "Filters",
            id: "zSOvI0"
        })
    });
};

// EXTERNAL MODULE: ./src/components/home/HomepageNavigation.tsx
var HomepageNavigation = __webpack_require__(72851);
;// CONCATENATED MODULE: ./src/components/home/pages/GovernmentsPage.tsx






















var MultiFacetSelect = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8201), __webpack_require__.e(6371)]).then(__webpack_require__.bind(__webpack_require__, 46371));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46371)
            ];
        }
    },
    ssr: false
});
var GovernmentsPage = function(_param) {
    var resultsState = _param.resultsState, widgetsCollector = _param.widgetsCollector, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "resultsState",
        "widgetsCollector"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(true), 2), on = ref[0], toggle = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentsPageSeo, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InstantSearch/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                indexName: (0,getIndexName/* default */.Z)("governments"),
                searchClient: algoliaClient/* default */.Z,
                resultsState: resultsState,
                widgetsCollector: widgetsCollector
            }, rest), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavbarLayout/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HomepageNavigation/* default */.Z, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            display: [
                                "flex",
                                "flex",
                                "flex",
                                "none"
                            ],
                            mb: 4,
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FiltersToggleButton, {
                                onClick: toggle,
                                active: on
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PageGridContainer */.pf, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SimpleGrid */.MI, {
                                    spacingX: 4,
                                    bg: [
                                        "none",
                                        "none",
                                        "none",
                                        "blue.100"
                                    ],
                                    px: [
                                        0,
                                        0,
                                        0,
                                        10
                                    ],
                                    py: [
                                        0,
                                        0,
                                        3
                                    ],
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: [
                                        "column",
                                        "column",
                                        "column",
                                        "row"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                            display: [
                                                "none",
                                                "none",
                                                "none",
                                                "flex"
                                            ],
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                                                    width: "17",
                                                    height: "10",
                                                    viewBox: "0 0 17 10",
                                                    fill: "none",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                        fillRule: "evenodd",
                                                        clipRule: "evenodd",
                                                        d: "M16.5 2H0.5V0H16.5V2ZM14.0999 6H2.8999V4H14.0999V6ZM5.2998 10H11.6998V8H5.2998V10Z",
                                                        fill: "#3F4A5A"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                    as: "span",
                                                    fontSize: "md",
                                                    ml: 3,
                                                    fontWeight: "semibold",
                                                    color: "#3F4A5A",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Filter by",
                                                        id: "S57QRB"
                                                    })
                                                })
                                            ]
                                        }),
                                        on && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                    mt: [
                                                        2,
                                                        2,
                                                        2,
                                                        0
                                                    ],
                                                    flex: 1,
                                                    width: [
                                                        "100%",
                                                        "100%",
                                                        "100%",
                                                        "auto"
                                                    ],
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchBox, {})
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClearStatesWithCountries, {}),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                    mt: [
                                                        2,
                                                        2,
                                                        2,
                                                        0
                                                    ],
                                                    width: [
                                                        "100%",
                                                        "100%",
                                                        "100%",
                                                        "auto"
                                                    ],
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CountriesFilter, {
                                                        attribute: "country",
                                                        limit: 100
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                    mt: [
                                                        2,
                                                        2,
                                                        2,
                                                        0
                                                    ],
                                                    width: [
                                                        "100%",
                                                        "100%",
                                                        "100%",
                                                        "auto"
                                                    ],
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatesFilter, {
                                                        attribute: "city.stateName",
                                                        limit: 500
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentResults, {})
                            ]
                        })
                    ]
                })
            }))
        ]
    });
};
var ClearStatesWithCountries = (0,connectCurrentRefinements/* default */.Z)(function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var countries = props.items.find(function(item) {
        return item.attribute === "country";
    });
    (0,react.useEffect)(function() {
        if (!(countries === null || countries === void 0 ? void 0 : countries.currentRefinement)) {
            props.refine(function(searchState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchState), {
                    refinementList: {
                        "city.stateName": []
                    }
                });
            });
        }
    }, [
        countries
    ]);
    return null;
});
var CountriesFilter = (0,connectRefinementList/* default */.Z)(function(param) {
    var refine = param.refine, items = param.items, currentRefinement = param.currentRefinement;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MultiFacetSelect, {
        selectedItems: currentRefinement,
        onChange: function(countries) {
            refine(countries);
        },
        ariaLabel: "Filter by Country",
        placeholder: currentRefinement.length > 0 ? currentRefinement.join(", ") : intl.formatMessage({
            defaultMessage: "Country",
            id: "vONi+O"
        }),
        items: items.map(function(item) {
            return {
                label: item.label,
                value: item.label
            };
        }).sort(function(a, b) {
            return a.label.localeCompare(b.label);
        })
    });
});
var StatesFilter = (0,connectRefinementList/* default */.Z)(function(param) {
    var refine = param.refine, items = param.items, currentRefinement = param.currentRefinement;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MultiFacetSelect, {
        selectedItems: currentRefinement,
        onChange: function(countries) {
            refine(countries);
        },
        ariaLabel: "Filter by State/Province/Territory",
        placeholder: currentRefinement.length > 0 ? currentRefinement.join(", ") : intl.formatMessage({
            defaultMessage: "State/Province/Territory",
            id: "SI/UQT"
        }),
        items: items.map(function(item) {
            return {
                label: item.label,
                value: item.label
            };
        }).filter(notUndefinedOrNull/* default */.Z).sort(function(a, b) {
            return a.label.localeCompare(b.label);
        })
    });
});
var SearchBox = (0,connectSearchBox/* default */.Z)(function(param) {
    var refine = param.refine, currentRefinement = param.currentRefinement;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Input */.II, {
        placeholder: intl.formatMessage({
            defaultMessage: "Search for governments...",
            id: "sOHiob"
        }),
        value: currentRefinement,
        onChange: function(e) {
            return refine(e.target.value);
        },
        width: "100%"
    });
});
var GovernmentResults = (0,connectInfiniteHits/* default */.Z)(function(param) {
    var hits = param.hits, hasMore = param.hasMore, refineNext = param.refineNext;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Configure/* default */.Z, {
                hitsPerPage: 30
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
                columns: [
                    1,
                    2,
                    3
                ],
                spacing: 6,
                mt: 6,
                children: hits.map(function(government) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "/government?governmentSlug=".concat(government.slug),
                        as: "/governments/".concat(government.slug),
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentWithTypeAndFlag, {
                            government: government
                        })
                    }, government.slug);
                })
            }),
            hasMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                display: "flex",
                justifyContent: "center",
                py: 6,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                    variant: "secondary",
                    size: "sm",
                    rightIcon: function(props) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            width: "24",
                            height: "12",
                            viewBox: "0 0 24 12",
                            fill: "none"
                        }, props), {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M2 2.5L11.7436 9.55882L22 2.5",
                                stroke: "currentColor",
                                strokeWidth: "3",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        }));
                    },
                    onClick: refineNext,
                    children: intl.formatMessage({
                        defaultMessage: "Show more",
                        id: "aWpBzj"
                    })
                })
            })
        ]
    });
});
/* harmony default export */ var pages_GovernmentsPage = (GovernmentsPage);
var GovernmentWithTypeAndFlag = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var government = _param.government, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "government"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        align: "center",
        overflow: "hidden",
        as: "a",
        ref: ref
    }, rest), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                size: "sm",
                name: government.name,
                src: government.logo
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                isTruncated: true,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        ml: 3,
                        isTruncated: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                            fontSize: "md",
                            color: "gray.600",
                            isTruncated: true,
                            children: government.name
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                        display: "inline-flex",
                        alignItems: "center",
                        ml: 3,
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CountryFlag */.AW, {
                                width: 24,
                                height: 14,
                                countryCode: government.city.country
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Text */.xv, {
                                fontSize: "sm",
                                color: "blue.600",
                                ml: 2,
                                mb: 0,
                                children: [
                                    (0,getCityType/* default */.Z)(government.city.governmentType),
                                    " - ",
                                    government.country
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
});
GovernmentWithTypeAndFlag.displayName = "GovernmentWithTypeAndFlag";

;// CONCATENATED MODULE: ./pages/governments.tsx









var Governments = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pages_GovernmentsPage, (0,_object_spread/* default */.Z)({}, props));
};
Governments.getInitialProps = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
    var resultsState;
    return runtime_default().wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.prev = 0;
                _ctx.next = 3;
                return (0,server.findResultsState)(pages_GovernmentsPage, {
                    searchClient: algoliaClient/* default */.Z,
                    searchState: {},
                    indexName: (0,getIndexName/* default */.Z)("governments")
                });
            case 3:
                resultsState = _ctx.sent;
                return _ctx.abrupt("return", {
                    resultsState: resultsState
                });
            case 7:
                _ctx.prev = 7;
                _ctx.t0 = _ctx["catch"](0);
                return _ctx.abrupt("return", {});
            case 10:
            case "end":
                return _ctx.stop();
        }
    }, _callee, null, [
        [
            0,
            7
        ]
    ]);
}));
/* harmony default export */ var governments = (Governments);


/***/ }),

/***/ 72851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HomepageNavigation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19026);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22051);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59496);
/* harmony import */ var _components_auth_Auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27068);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69057);










function HomepageNavigation() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var tabsRef = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.createRef)();
    var viewer = (0,_components_auth_Auth__WEBPACK_IMPORTED_MODULE_4__/* .useSelfie */ .yD)();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var pathname = router === null || router === void 0 ? void 0 : router.pathname;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (!tabsRef.current) {
            return;
        }
        if (pathname === "/vendors") {
            tabsRef.current.scrollLeft = 200;
        }
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
                overflow: "hidden",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
                    display: [
                        "flex",
                        "flex",
                        "none"
                    ],
                    overflowX: [
                        "scroll",
                        "scroll",
                        "auto"
                    ],
                    ref: tabsRef,
                    alignItems: "center",
                    justifyContent: "space-between",
                    bg: "white",
                    mb: 2,
                    px: 2,
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/collections",
                            passHref: true,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MobileNavigationItem, {
                                icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    css: {
                                        marginLeft: 4
                                    },
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M2.30769 0C1.67521 0 1.07368 0.2244 0.649038 0.649038C0.2244 1.07368 0 1.67521 0 2.30769V5.38462V8.46154V17.6923C0 18.3248 0.2244 18.9263 0.649038 19.351C1.07368 19.7756 1.67521 20 2.30769 20H5H17.6923H18C19.1046 20 20 19.1046 20 18V17.6923V9.23077V8.46154V8V6.92308V5.38462C20 4.75214 19.7756 4.1506 19.351 3.72596C18.9263 3.30132 18.3248 3.07692 17.6923 3.07692H9.23077V2.30769C9.23077 1.67521 9.00637 1.07368 8.58173 0.649038C8.15709 0.2244 7.55556 0 6.92308 0H2.30769ZM18 6C18.1589 6 18.3134 6.01852 18.4615 6.05352V5.38462C18.4615 5.09402 18.377 4.92752 18.2632 4.8137C18.1494 4.69988 17.9829 4.61538 17.6923 4.61538H9.23077C8.82906 4.61538 8.41803 4.46971 8.12801 4.17969C7.83798 3.88966 7.69231 3.47863 7.69231 3.07692V2.30769C7.69231 2.01709 7.60781 1.8506 7.49399 1.73678C7.38017 1.62296 7.21368 1.53846 6.92308 1.53846H2.30769C2.01709 1.53846 1.8506 1.62296 1.73678 1.73678C1.62296 1.8506 1.53846 2.01709 1.53846 2.30769V5.38462V8.46154V17.6923C1.53846 17.9829 1.62296 18.1494 1.73678 18.2632C1.8506 18.377 2.01709 18.4615 2.30769 18.4615C2.59829 18.4615 2.76478 18.377 2.87861 18.2632C2.92616 18.2157 2.9686 18.1589 3.00189 18.0878C3.00064 18.0587 3 18.0294 3 18V8C3 6.89543 3.89543 6 5 6H18ZM12.9548 11.4977L11.5 9L10.0452 11.4977L7.22025 12.1094L9.14614 14.2648L8.85497 17.1406L11.5 15.975L14.145 17.1406L13.8539 14.2648L15.7798 12.1094L12.9548 11.4977Z",
                                        fill: "currentColor"
                                    })
                                }),
                                label: intl.formatMessage({
                                    defaultMessage: "Collections",
                                    id: "ulh3kf"
                                }),
                                active: pathname === "/" || pathname === "/collections"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/governments",
                            passHref: true,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MobileNavigationItem, {
                                icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                        d: "M20.7778 19.0006H19.5556V10.445H20.7778C21.3046 10.445 21.7702 10.1089 21.9364 9.60902C22.1039 9.11035 21.9316 8.56035 21.5099 8.24502L11.7321 0.911682C11.2982 0.584127 10.7006 0.584127 10.2667 0.911682L0.488889 8.24502C0.0684444 8.56035 -0.103889 9.11035 0.0635556 9.60902C0.229778 10.1089 0.695444 10.445 1.22222 10.445H2.44444V19.0006H1.22222C0.546333 19.0006 0 19.5469 0 20.2228C0 20.8987 0.546333 21.445 1.22222 21.445H20.7778C21.4537 21.445 22 20.8987 22 20.2228C22 19.5469 21.4537 19.0006 20.7778 19.0006ZM11 3.41724L17.1111 8.00057H4.88889L11 3.41724ZM4.88889 19.0006V10.445H7.33333V19.0006H4.88889ZM9.77778 19.0006V10.445H12.2222V19.0006H9.77778ZM14.6667 19.0006V10.445H17.1111V19.0006H14.6667Z",
                                        fill: "currentColor"
                                    })
                                }),
                                label: intl.formatMessage({
                                    defaultMessage: "Governments",
                                    id: "qnQX9U"
                                }),
                                active: pathname === "/governments"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/vendors",
                            passHref: true,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MobileNavigationItem, {
                                icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                        d: "M12 2C6.47714 2 2 6.47714 2 12C2 17.5229 6.47714 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47714 17.5229 2 12 2ZM12.9127 17.88V19.8175H11.0476V18.0138C9.7381 17.9565 8.51409 17.6123 7.78746 17.1916L8.35639 14.9543C9.15952 15.3942 10.2854 15.7957 11.5283 15.7957C12.6183 15.7957 13.3629 15.375 13.3629 14.6102C13.3629 13.8835 12.7504 13.4246 11.3353 12.9465C9.28925 12.2581 7.89436 11.3021 7.89436 9.44722C7.89436 7.76448 9.06349 6.44508 11.127 6.04353V4.22222H12.9921V5.90968C14.2619 5.96706 15.1368 6.23476 15.7679 6.54071L15.2149 8.70151C14.7177 8.49115 13.8389 8.05135 12.4621 8.05135C11.2192 8.05135 10.818 8.58679 10.818 9.12218C10.818 9.75321 11.4875 10.1548 13.1128 10.7667C15.3883 11.5698 16.3113 12.6215 16.3113 14.3424C16.3113 16.0443 15.0952 17.4976 12.9127 17.88Z",
                                        fill: "currentColor"
                                    })
                                }),
                                label: intl.formatMessage({
                                    id: "RilevA",
                                    defaultMessage: "Vendors"
                                }),
                                active: pathname === "/vendors"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .PageGridContainer */ .pf, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
                    display: [
                        "none",
                        "none",
                        "flex"
                    ],
                    justifyContent: "flex-start",
                    alignItems: "center",
                    mb: 8,
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(NavigationItem, {
                            icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M2.30769 0C1.67521 0 1.07368 0.2244 0.649038 0.649038C0.2244 1.07368 0 1.67521 0 2.30769V5.38462V8.46154V17.6923C0 18.3248 0.2244 18.9263 0.649038 19.351C1.07368 19.7756 1.67521 20 2.30769 20H5H17.6923H18C19.1046 20 20 19.1046 20 18V17.6923V9.23077V8.46154V8V6.92308V5.38462C20 4.75214 19.7756 4.1506 19.351 3.72596C18.9263 3.30132 18.3248 3.07692 17.6923 3.07692H9.23077V2.30769C9.23077 1.67521 9.00637 1.07368 8.58173 0.649038C8.15709 0.2244 7.55556 0 6.92308 0H2.30769ZM18 6C18.1589 6 18.3134 6.01852 18.4615 6.05352V5.38462C18.4615 5.09402 18.377 4.92752 18.2632 4.8137C18.1494 4.69988 17.9829 4.61538 17.6923 4.61538H9.23077C8.82906 4.61538 8.41803 4.46971 8.12801 4.17969C7.83798 3.88966 7.69231 3.47863 7.69231 3.07692V2.30769C7.69231 2.01709 7.60781 1.8506 7.49399 1.73678C7.38017 1.62296 7.21368 1.53846 6.92308 1.53846H2.30769C2.01709 1.53846 1.8506 1.62296 1.73678 1.73678C1.62296 1.8506 1.53846 2.01709 1.53846 2.30769V5.38462V8.46154V17.6923C1.53846 17.9829 1.62296 18.1494 1.73678 18.2632C1.8506 18.377 2.01709 18.4615 2.30769 18.4615C2.59829 18.4615 2.76478 18.377 2.87861 18.2632C2.92616 18.2157 2.9686 18.1589 3.00189 18.0878C3.00064 18.0587 3 18.0294 3 18V8C3 6.89543 3.89543 6 5 6H18ZM12.9548 11.4977L11.5 9L10.0452 11.4977L7.22025 12.1094L9.14614 14.2648L8.85497 17.1406L11.5 15.975L14.145 17.1406L13.8539 14.2648L15.7798 12.1094L12.9548 11.4977Z",
                                    fill: "currentColor"
                                })
                            }),
                            label: intl.formatMessage({
                                defaultMessage: "Collections",
                                id: "ulh3kf"
                            }),
                            href: viewer ? "/" : "/collections",
                            active: pathname === "/" || pathname === "/collections"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(NavigationItem, {
                            icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                    d: "M20.7778 19.0006H19.5556V10.445H20.7778C21.3046 10.445 21.7702 10.1089 21.9364 9.60902C22.1039 9.11035 21.9316 8.56035 21.5099 8.24502L11.7321 0.911682C11.2982 0.584127 10.7006 0.584127 10.2667 0.911682L0.488889 8.24502C0.0684444 8.56035 -0.103889 9.11035 0.0635556 9.60902C0.229778 10.1089 0.695444 10.445 1.22222 10.445H2.44444V19.0006H1.22222C0.546333 19.0006 0 19.5469 0 20.2228C0 20.8987 0.546333 21.445 1.22222 21.445H20.7778C21.4537 21.445 22 20.8987 22 20.2228C22 19.5469 21.4537 19.0006 20.7778 19.0006ZM11 3.41724L17.1111 8.00057H4.88889L11 3.41724ZM4.88889 19.0006V10.445H7.33333V19.0006H4.88889ZM9.77778 19.0006V10.445H12.2222V19.0006H9.77778ZM14.6667 19.0006V10.445H17.1111V19.0006H14.6667Z",
                                    fill: "currentColor"
                                })
                            }),
                            label: intl.formatMessage({
                                defaultMessage: "Governments",
                                id: "qnQX9U"
                            }),
                            href: "/governments",
                            active: pathname === "/governments"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(NavigationItem, {
                            icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                    d: "M12 2C6.47714 2 2 6.47714 2 12C2 17.5229 6.47714 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47714 17.5229 2 12 2ZM12.9127 17.88V19.8175H11.0476V18.0138C9.7381 17.9565 8.51409 17.6123 7.78746 17.1916L8.35639 14.9543C9.15952 15.3942 10.2854 15.7957 11.5283 15.7957C12.6183 15.7957 13.3629 15.375 13.3629 14.6102C13.3629 13.8835 12.7504 13.4246 11.3353 12.9465C9.28925 12.2581 7.89436 11.3021 7.89436 9.44722C7.89436 7.76448 9.06349 6.44508 11.127 6.04353V4.22222H12.9921V5.90968C14.2619 5.96706 15.1368 6.23476 15.7679 6.54071L15.2149 8.70151C14.7177 8.49115 13.8389 8.05135 12.4621 8.05135C11.2192 8.05135 10.818 8.58679 10.818 9.12218C10.818 9.75321 11.4875 10.1548 13.1128 10.7667C15.3883 11.5698 16.3113 12.6215 16.3113 14.3424C16.3113 16.0443 15.0952 17.4976 12.9127 17.88Z",
                                    fill: "currentColor"
                                })
                            }),
                            label: intl.formatMessage({
                                id: "RilevA",
                                defaultMessage: "Vendors"
                            }),
                            href: "/vendors",
                            active: pathname === "/vendors"
                        })
                    ]
                })
            })
        ]
    });
};
function NavigationItem(param) {
    var icon = param.icon, label = param.label, href = param.href, active = param.active;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
            as: "a",
            display: "flex",
            alignItems: "center",
            mr: 6,
            color: active ? "blue.600" : "gray.800",
            mt: [
                4,
                4,
                0
            ],
            children: [
                icon,
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
                    fontSize: "md",
                    fontWeight: "semibold",
                    ml: 2,
                    as: active ? "h1" : "p",
                    children: label
                })
            ]
        })
    });
}
var MobileNavigationItem = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(function(_param, ref) {
    var icon = _param.icon, label = _param.label, active = _param.active, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "icon",
        "label",
        "active"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        as: "a",
        color: active ? "blue.600" : "gray.800",
        display: "flex",
        flexDirection: [
            "column",
            "column",
            "row"
        ],
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        minHeight: "72px",
        borderTop: "1px",
        borderTopWidth: "5px",
        py: 2,
        px: [
            "8px",
            "8px",
            "24px"
        ],
        borderColor: active ? "blue.600" : "transparent",
        ref: ref,
        _hover: {
            bg: "blue.50"
        }
    }, props), {
        children: [
            icon,
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
                fontWeight: "semibold",
                fontSize: [
                    "md",
                    "md",
                    "lg"
                ],
                whiteSpace: "nowrap",
                mt: 1,
                children: label
            })
        ]
    }));
});
MobileNavigationItem.displayName = "MobileNavigationItem";


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3481,5522,3685,6514,9932,2888,179], function() { return __webpack_exec__(50119); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);